import React from 'react';
import ReactDOM from 'react-dom/client';
import ErrorTip from './index';

class ErrorTipManager {
  static instance = null;
  container = null;
  root = null;
  timer = null;

  constructor() {
    const div = document.createElement('div');
    document.body.appendChild(div);
    this.container = div;
    this.root = ReactDOM.createRoot(div);
  }

  static getInstance() {
    if (!ErrorTipManager.instance) {
      ErrorTipManager.instance = new ErrorTipManager();
    }
    return ErrorTipManager.instance;
  }

  open(config) {
    const { content, type = 'error', duration } = config;

    // 清除之前的定时器
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    // 渲染新的提示
    this.root.render(<ErrorTip message={content} type={type} />);

    // 只有当 duration 存在时才设置定时器
    if (duration) {
      this.timer = setTimeout(() => {
        this.root.render(null);
        this.timer = null;
      }, duration);
    }
  }

  destroy() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    if (this.container) {
      this.root.unmount();
      document.body.removeChild(this.container);
    }
  }

  // 添加关闭方法
  close() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.root.render(null);
  }
}

const errorTip = {
  open: (config) => ErrorTipManager.getInstance().open(config),
  error: (content, duration) =>
    ErrorTipManager.getInstance().open({ type: 'error', content, duration }),
  success: (content, duration) =>
    ErrorTipManager.getInstance().open({ type: 'success', content, duration }),
  warning: (content, duration) =>
    ErrorTipManager.getInstance().open({ type: 'warning', content, duration }),
  close: () => ErrorTipManager.getInstance().close(),
};

export default errorTip;
